import * as React from 'react';
import { Heading } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';

const TitleWithIcon = ({ label , icon , hideIcon =false , hideAsteriskSign =true  })=>/*#__PURE__*/ React.createElement("div", {
        className: "checkout-step-title"
    }, !hideIcon && /*#__PURE__*/ React.createElement("div", {
        className: "checkout-step-title__icon"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: icon
    })), /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h2",
        className: !hideIcon ? 'checkout-step-title__heading checkout-step-title__heading--icon' : 'checkout-step-title__heading'
    }, label, !hideAsteriskSign && /*#__PURE__*/ React.createElement("span", {
        className: "checkout-step-title__asterisk"
    }, "*")))
;

export { TitleWithIcon };
//# sourceMappingURL=TitleWithIcon.js.map
